import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

export const HtmlDescription = ({
  content,
  size = 'base',
  className,
}: {
  content: string;
  className?: string;
  size?: 'sm' | 'base';
}) => {
  return (
    <HtmlRendererRaw
      className={cn(
        'ea-html-description',
        className,
        size === 'sm' && 'ea-html-description--sm',
        size === 'base' && 'ea-html-description--base',
      )}
      html={content}
    />
  );
};
